module.exports = __webpack_public_path__ + "img/dollar.531ee923.svg";